import Env from '../../base/env'
import Channels from '../../base/channels'

export default class CrewTouch
{
    constructor(view)
    {
        // DOM
        this.view = view
        this.$collection = this.view.querySelector('.jsCollection')
        this.$items = this.view.querySelectorAll('.jsItem')
        // Popin
        this.$popin = Env.$popinView
        this.$popinReceptor = this.$popin.querySelector('.jsReceptor')
        this.$popinClose = this.$popin.querySelector('.jsClose')
        // Objects
        this.bounds = {}
        this.TOTAL = this.$items.length - 1
        this.minX = 30
        // Fns
        this.funcResize = this.resize.bind(this)
    }

    configure()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const $lastItem = this.$items[this.TOTAL]
        const coordinates = $lastItem.getBoundingClientRect()
        let lastPoint = coordinates.left + coordinates.width
        let lastMarginRight = (Env.mobileCSS)?30:0
        lastPoint += lastMarginRight + this.minX
        $lastItem.classList.add('is--last')
        this.$collection.style.width = `${lastPoint}px`
        this.bounds = { minX : this.minX , maxX : (lastPoint - viewport.width) * -1 , minY : 0, maxY : 0 }
        TweenLite.set(this.$collection , {  x : this.minX })
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcResize)
    }

    draggable()
    {
        let settings = {}
        settings.lock = true
        settings.type = "x"
        settings.dragResistance = .3
        settings.maxDuration = 1.5
        this.configure()
        // Drag
        this.instanceDrag = Draggable.create(
            this.$collection,
            {
                cursor: 'grab',
                type:settings.type,
                edgeResistance:.99,
                dragResistance : settings.dragResistance,
                force3D : false,
                lockAxis : settings.lock,
                throwProps:true,
                minDuration:.5,
                maxDuration:settings.maxDuration,
                throwResistance: 3000,
                dragClickables : true,
                bounds : this.bounds
            }
        )
    }

    resize()
    {
        if(Env.mobileCSS == false) {
            this.instanceDrag[0].kill()
            this.instanceDrag = false
            TweenLite.set(this.$collection , { clearProps : 'all' })
            TweenLite.set(this.$collection , { x : 0 , width : 99999 })
            this.bounds = {}
            this.draggable()
        }
    }

    setup()
    {
        this.draggable()
    }

}


// WEBPACK FOOTER //
// ./resources/js/components/crew/Touch.js